import { http } from "../http/Http";
import { Transport } from "../models/Transport";
import { ServiceResponse } from "../models/ServiceResponse";

export class TransportService {

    getTransports = async (): Promise<ServiceResponse<Transport[]>> => {
        const { data } = await http.get<ServiceResponse<Transport[]>>("Transport/GetAll");
        return data;
    };

}